const SelectionModes = Object.freeze({
	All: "all",
	Random: "random",
});

type SelectionMode = typeof SelectionModes[keyof typeof SelectionModes];

export default SelectionMode;
export {SelectionModes};
